export default "__VITE_ASSET__BOTSpEDN__"